import { service } from "@server/client";
import type {
  GetAdyenCheckoutOrderForCompleteQuery,
  GetAdyenCheckoutOrderForCompleteQueryVariables,
} from "@server/gql/graphql";
import { getAdyenCheckoutOrderForCompleteQuery } from "@server/queries/checkout";

export const getAdyenCheckoutOrderForComplete = async (
  variables: GetAdyenCheckoutOrderForCompleteQueryVariables,
) => {
  try {
    const response = await service<
      GetAdyenCheckoutOrderForCompleteQuery,
      GetAdyenCheckoutOrderForCompleteQueryVariables
    >({
      query: getAdyenCheckoutOrderForCompleteQuery,
      variables,
    });

    return response.adyenCheckoutOrderForComplete;
  } catch (error: Error | unknown) {
    console.error("Error in adyenCheckoutOrderForComplete", error);
    throw error;
  }
};
